import React, { createContext, useContext } from 'react';
import { useSystemMessages } from '../components/SystemMessages';

const SystemMessagesContext = createContext();

export const useSystemMessagesContext = () => {
  const context = useContext(SystemMessagesContext);
  if (!context) {
    throw new Error('useSystemMessagesContext deve ser usado dentro de um SystemMessagesProvider');
  }
  return context;
};

export const SystemMessagesProvider = ({ children }) => {
  const systemMessages = useSystemMessages();

  return (
    <SystemMessagesContext.Provider value={systemMessages}>
      {children}
    </SystemMessagesContext.Provider>
  );
}; 